var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4665 17.1428H1.53795C1.16473 17.1428 0.859375 16.8375 0.859375 16.4643V1.53568C0.859375 1.16247 1.16473 0.857109 1.53795 0.857109H16.4665C16.8397 0.857109 17.1451 1.16247 17.1451 1.53568V16.4643C17.1451 16.8375 16.8397 17.1428 16.4665 17.1428ZM2.21652 15.7857H15.7879V2.21425H2.21652V15.7857Z",
    fill: "#3C7AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0391 11.7143H6.96763C6.59442 11.7143 6.28906 11.4089 6.28906 11.0357V6.96425C6.28906 6.59104 6.59442 6.28568 6.96763 6.28568H11.0391C11.4123 6.28568 11.7176 6.59104 11.7176 6.96425V11.0357C11.7176 11.4089 11.4123 11.7143 11.0391 11.7143ZM7.64621 10.3571H10.3605V7.64283H7.64621V10.3571Z",
    fill: "#3C7AF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3956 14.4285H4.25279C3.87958 14.4285 3.57422 14.1232 3.57422 13.75V4.24997C3.57422 3.87675 3.87958 3.5714 4.25279 3.5714H13.7528C14.126 3.5714 14.4314 3.87675 14.4314 4.24997V8.3214C14.4314 8.69461 14.126 8.99997 13.7528 8.99997H11.0385C10.6653 8.99997 10.3599 8.69461 10.3599 8.3214C10.3599 7.94818 10.6653 7.64282 11.0385 7.64282H13.0742V4.92854H4.93136V13.0714H12.1174L13.2778 11.911C13.5424 11.6464 13.9699 11.6464 14.2346 11.911C14.4992 12.1757 14.4992 12.6032 14.2346 12.8678L12.8774 14.225C12.7485 14.3539 12.5789 14.4218 12.3956 14.4218V14.4285Z",
    fill: "#3C7AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/template-icon.38c73d589732de1aaac150d88571c303.svg";
export { ForwardRef as ReactComponent };